<template>
  <cargo-left-right-resize
    ref="cargoLeftRightResize"
    :left-style="{flex:'none','max-width':'700px',width:cargoLfResizeCacheValue.leftW}"
    :right-style="{'overflow': 'hidden',width:cargoLfResizeCacheValue.rightW}"
    style="min-height:100%"
    @onSize="cargoLfResizeCacheValue = $event;"
  >
    <template slot="left">
      <div style="width:100%;min-width:190px;height:100%;cursor: pointer;padding: 5px;background-color: #F5F7FA;">
        <cargo-ag-grid
          :show-side-bar="false"
          config-module="20220812"
          :grid-options="officeDeptTree.gridOptions"
          :column-defs="officeDeptTree.columnDefs"
          :row-data="officeDeptTree.rowData"
          style="width:100%;height:100%"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
    </template>
    <template slot="right">
      <div style="overflow-y: scroll;height:100%;width: 100%;">
        <office-tab v-if="currentComponent==='officeTab'" ref="officeTab" :dept-list="deptList" :image-type-list="imageTypeList" :tree-node="currentState.treeNode" :office-count="officeCount" @refreshTree="toRefreshTree" @editData="editHandler" @addDept="officeToAddDept" />
        <dept-tab v-else-if="currentComponent==='deptTab'" ref="deptTab" :source-type="currentState.dept.sourceType" :tree-node="currentState.treeNode" @editData="editHandler" @refreshTree="toRefreshTree" @addRole="deptToAddRole" @cancel="toBackOffice4Dept" />
        <role-tab v-else-if="currentComponent==='roleTab'" ref="roleTab" :source-type="currentState.role.sourceType" :tree-node="currentState.treeNode" @editData="editHandler" @refreshTree="toRefreshTree" @cancel="toBackDept4Role" />
      </div>
    </template>
  </cargo-left-right-resize>
</template>
<script>

import officeTab from './components/role/officeTab'
import roleTab from './components/role/roleTab'
import deptTab from './components/role/deptTab'
import { copyRole, getOfficeDeptTree } from '@/api/office'
import { getLoading } from '@/utils/utilBaseElement'
import { getImageTypeList } from '@/api/imageType'
import { ensureExecuteSuccess, sleep } from '@/utils/commonUtil'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize.vue'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'

export default {
  name: 'FmPrivilege',
  components: {
    cargoLeftRightResize,
    deptTab, officeTab, roleTab
  },
  filters: {},
  data() {
    const isZh = this.$store.getters.language === 'zh'
    return {
      isZh,
      loading: null,
      currentComponent: 'officeTab',
      defaultSourceType: 'clickTree',
      isEdit: false,
      gridApi: null,
      expandedList: [],
      oldSelectedData: '',
      imageTypeList: [],
      deptList: [], // 当前选中分公司下全部部门
      copyDataSelect: {}, // 复制的数据
      currentState: {
        treeNode: {}, // 当前点击的节点
        office: {
          uuid: ''
        },
        dept: {
          uuid: '',
          sourceType: this.defaultSourceType
        },
        role: {
          uuid: '',
          sourceType: this.defaultSourceType
        }

      },
      officeDeptTree: {
        columnDefs: [
          {
            headerName: 'Path',
            field: 'path',
            width: 80,
            hide: true
          }
        ],
        rowData: [],
        gridOptions: {
          rowSelection: 'multiple',
          groupDefaultExpanded: 1,
          suppressRowClickSelection: true,
          treeData: true,
          getContextMenuItems: () => {
            const self = this
            const menu = [
              {
                name: this.$t('SystemMaintenance.CopyRole'),
                hide: true,
                action: function() {
                  self.copySelectRoleHandler()
                }
              }, {
                name: this.$t('SystemMaintenance.PasteRole'),
                hide: false,
                action: function() {
                  self.pasteRoleHandler()
                }
              }
            ]
            return menu
          },
          getDataPath: (data) => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('CargoMsg.Cargo_Name'),
            width: 280,
            tooltipValueGetter: (params) => {
              return ''
            },
            cellRendererParams: {
              suppressCount: true,
              suppressDoubleClickExpand: true,
              innerRenderer: (params) => {
                const name = isZh ? params.data.chineseName : (params.data.englishName || params.data.chineseName)
                if (params.data.code) {
                  return `[${params.data.code}]` + name
                } else {
                  return name
                }
              },
              checkbox: (params) => {
                return params.data.type === 3
              }
            },
            cellStyle: params => {
              if (!params.data.haveChild && params.data.type !== 3) {
                return {
                  paddingLeft: `23px !important;`
                }
              }
            },
            suppressMenu: true
          },
          onRowDataChanged: event => {
            event.api.clearFocusedCell()
            if (this.expandedList.length > 0) {
              setTimeout(() => {
                const nodes = this.gridApi.rowModel.rootNode.allLeafChildren
                for (const p of nodes) {
                  const index = this.expandedList.findIndex(e => e.key === p.key)
                  if (index > -1) {
                    p.expanded = true
                  }
                }
                if (this.oldSelectedData) {
                  const i = nodes.findIndex(n => n.key === this.oldSelectedData)
                  if (i > -1) {
                    const n = nodes[i]
                    n.expanded = true
                    n.selected = true
                    if (n.parent) {
                      n.parent.expanded = true
                    }
                    if (n) {
                      this.toRefreshTreeHandler(n)
                    }
                  }
                }
                if (this.gridApi) {
                  this.gridApi.onGroupExpandedOrCollapsed()
                }
              }, 100)
            }
          },
          onRowClicked: this.onRowClicked
        }
      }
    }
  },
  computed: {
    officeCount() {
      return this.officeDeptTree.rowData.filter(p => p.type === 1).length
    },
    cargoLfResizeCacheValue: {
      get() {
        return LocalStorageUtilsNew.getConfiguration('fmPrivCResizeCache') || {}
      },
      set(newValue) {
        LocalStorageUtilsNew.setConfiguration('fmPrivCResizeCache', newValue)
      }
    }
  },
  mounted() {
    this.fetchOfficeDeptTree()
    this.initData()
  },
  methods: {
    initData() {
      getImageTypeList().then(res => {
        this.imageTypeList = res.data
      })
      if (this.gridApi) {
        sleep(100)
      } else {
        // 等待gridApi被赋值
        ensureExecuteSuccess(() => this.gridApi)
      }
    },
    async toRefreshTree(uuid = null) {
      // 记录上次打开的节点 刷新后再次打开
      this.expandedList = []
      this.oldSelectedData = uuid
      this.officeDeptTree.gridOptions.api.forEachNode(node => {
        if (node.expanded) {
          this.expandedList.push(node)
        }
      })
      await this.fetchOfficeDeptTree()
    },
    onRowClicked(event) {
      this.toRefreshTreeHandler(event.node)
    },
    toRefreshTreeHandler(node) {
      this.deptList = []
      let currentType = ''
      if (node.data.type === 1) {
        // 公司
        currentType = 'officeTab'
        this.currentState.office.sourceType = this.defaultSourceType
        const nodes = node.allLeafChildren
        if (nodes) {
          for (const n of nodes) {
            if (n.data.type === 2) {
              this.deptList.push(n.data)
            }
          }
        }
      } else if (node.data.type === 2) {
        // 部门
        currentType = 'deptTab'
        this.currentState.dept.sourceType = this.defaultSourceType
      } else if (node.data.type === 3) {
        // 角色
        currentType = 'roleTab'
        this.currentState.role.sourceType = this.defaultSourceType
      } else if (node.data.type === 101) {
        // 特殊角色根，不做处理
        return
      }
      this.currentState.treeNode = { ...node.data, hasChild: node.hasChildren() }
      this.currentComponent = currentType
    },
    fetchOfficeDeptTree() {
      this.loading = getLoading()
      getOfficeDeptTree().then(res => {
        this.officeDeptTree.rowData = res.data
      }).finally(() => {
        this.loading.close()
      })
    },
    expandedNode(expandedNode) {
      if (expandedNode) {
        expandedNode.expanded = true
      }
    },
    officeToAddDept() {
      this.currentState.dept.sourceType = 'officeTab'
      this.currentComponent = 'deptTab'
    },
    toBackOffice4Dept() { // 从部门返回到公司
      this.currentState.dept.sourceType = this.defaultSourceType
      this.currentComponent = 'officeTab'
    },
    deptToAddRole() {
      this.currentState.role.sourceType = 'deptTab'
      this.currentComponent = 'roleTab'
    },
    toBackDept4Role() {
      this.currentState.role.sourceType = this.defaultSourceType
      this.currentComponent = 'deptTab'
    },
    editHandler(edit) {
      this.isEdit = edit
      if (this.gridApi) {
        this.gridApi.onGroupExpandedOrCollapsed()
      }
    },
    // 复制角色
    copySelectRoleHandler() {
      if (!this.currentState || !this.currentState.treeNode || this.currentState.treeNode.typeDesc !== 'role') {
        this.$message.warning(this.$t('SystemMaintenance.PleaseRoleYouWantCopy'))
        return
      }
      this.copyDataSelect = this.currentState.treeNode
    },
    // 粘贴角色
    pasteRoleHandler() {
      if (!this.copyDataSelect) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseRoleYouWantCopy'))
        return
      }
      if (!this.currentState || !this.currentState.treeNode || this.currentState.treeNode.typeDesc !== 'dept') {
        this.$message.warning(this.$t('SystemMaintenance.PleaseYouWantToRole'))
        return
      }
      const nodes = this.officeDeptTree.rowData
      const nowDept = []
      for (const p of nodes) {
        if (p.typeDesc === 'role' && p.parentUuid === this.currentState.treeNode.uuid) {
          nowDept.push(p)
        }
      }
      this.loading = getLoading()
      // 检查当前部门下是否存在重名的
      const name = this.checkName(nowDept, this.copyDataSelect.chineseName, 1)
      copyRole({ uuid: this.copyDataSelect.uuid, name: name, roleId: 0, office: this.currentState.treeNode.officeUuid, department: this.currentState.treeNode.uuid }).then(res => {
        this.toRefreshTree(res.data.department)
      }).finally((e) => {
        this.loading.close()
      })
    },
    checkName(nowDept, name, num) {
      const index = nowDept.findIndex(p => p.chineseName === name)
      if (index >= 0) {
        num += 1
        name = this.copyDataSelect.chineseName + '_' + num
        return this.checkName(nowDept, name, num)
      }
      return name
    }
  }
}
</script>
<style lang="scss" scoped>
  //::-webkit-scrollbar {
  //  width: 0 !important;
  //}
  //::-webkit-scrollbar {
  //  width: 0 !important; height:0;
  //}
</style>
